module.exports = __webpack_public_path__ + "static/media/image7.eddf25b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DreamGarage/image7.png
// module id = 1155
// module chunks = 0